import React from 'react';
import AdminAgentsComp from '../../components/AdminAgentsComp';

function AdminAgents({ token }) {
  // Show only activated and legacy (null status) agents - exclude pending
  return <AdminAgentsComp token={token} filterByStatus="active" pageTitle="Active Agents" />
}

export default AdminAgents;
